import { getOrdoclicIconnectApi } from '../../api/apisauceConfig'

export const disconnectOrdoclicSession = () =>
  getOrdoclicIconnectApi().get('/oauth2/sessions/logout')
